import { render } from "./PaymentMethodLabel.vue?vue&type=template&id=99290e84"
import script from "./PaymentMethodLabel.vue?vue&type=script&lang=js"
export * from "./PaymentMethodLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__